<label [for]="for" [id]="id" [ngClass]="class">
  {{ labelText }}
</label>
